import { Box } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'

export const BoxWrap = withStyles((theme) => ({
  root: {
    position: 'absolute',
    top: `${theme.constants.toolbar.height}px`,
    left: 0,
    width: '100%',
    zIndex: 100,
    padding: '32px 0',
    overflow: 'hidden',
  },
}))(Box)
